import { useRouter } from 'next/router';

export interface UseCatalogSchemaType {
  isSingleSchema: boolean;
}

const useCatalogSchema = (): UseCatalogSchemaType => {
  const router = useRouter();
  const isCampaign = router.pathname.search('/c/') >= 0;
  const schemaCatalogPage = {
    isSingleSchema: !isCampaign,
  };
  return schemaCatalogPage;
};

export default useCatalogSchema;
